export default {  
    accept:"Hyväksy",
    average:"Keskiarvo",
    cancel:"Peruuta",
    categories:"Kategoriat",
    categoryDist:"Kategorioiden jakauma",
    clear:"Tyhjennä",
    clickOnDate:"Klikkaa päivämäärää, johon haluat lisätä ohjelman",
    confirmDel:"Haluatko varmasti poistaa tämän ohjelman?",
    copy:"Kopioi",
    contact:"Ota meihin yhteyttä",
    contactDes: 'Huollon reagoinnin vasteaika on 24h arkipäivinä. Jos vika ilmoitetaan viikonloppuna, vastataan siihen seuraavan arkipäivän aikana.',
    copiedWeek:"Kopioitu viikko",
    delete:"Poista",
    devStatus:"Laitteeni",
    dislikes:"Ei tykkää",
    dislikesPeriod:"Ei tykkää tänä aikana",
    likes: 'Tykkää',
    likesPeriod:"Tykkää tänä aikana",
    logoff:"Kirjaudu ulos",
    maintenance:"Ajoitettu huolto keskiviikkona 4.7.18 klo 7.00-11.00.",
    modify:"Muokkaa",
    mostLikedVideo:"Tykätyin Video",
    mostViewedCategory:"Katsotuin Kategoria",
    mostViewedVideo:"Katsotuin Video",    
    paste:"Liitä",
    save:"Tallenna",
    summary:"Yhteenveto",    
    views: 'Katselukerrat',
    viewsPeriod:"Katselukerrat tänä aikana",
    week: 'Viikko',
    weekControl:"Viikon hallinta",
    welcome:"Tervetuloa",
}


// WEBPACK FOOTER //
// ./src/lang/fi/index.js